<template>
  <div class="editProfile">
    <van-form
      ref="validateForm"
      validate-first
      input-align="right"
      :show-error="false"
      :show-error-message="false"
    >
      <van-field
        required
        autosize
        v-model.trim="userInfo.name"
        label="真实姓名"
        placeholder="请输入真实姓名"
        :rules="[{ required: true, message: '请输入真实姓名' }]"
      />
      <!-- 党政干部不需要身份认证 -->
      <van-field
        v-if="!isManage"
        v-model.trim="userInfo.idCardNo"
        label="身份证号"
        readonly
      >
        <template v-if="!userInfo.idCardNo" #button>
          <van-button
            size="small"
            type="primary"
            color="#1972ff"
            @click="toIdentify"
            >前往身份认证</van-button
          >
        </template>
      </van-field>
      <van-field label="性别" placeholder="请选择性别" key="gender">
        <template #input>
          <van-radio-group v-model="userInfo.gender" direction="horizontal">
            <van-radio :name="1">男</van-radio>
            <van-radio :name="2">女</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <!-- 出生日期 -->
      <van-field
        readonly
        clickable
        right-icon="arrow"
        :value="userInfo.birthday && userInfo.birthday.substring(0, 11)"
        label="出生日期"
        placeholder="请选择出生日期"
        @click="showBirthdayPicker = true"
      />
      <van-popup v-model="showBirthdayPicker" round position="bottom">
        <van-datetime-picker
          v-model="currentDate"
          type="date"
          title="请选择出生日期"
          :min-date="minDate"
          :max-date="maxDate"
          @confirm="birthdayOnConfirm"
          @cancel="showBirthdayPicker = false"
        />
      </van-popup>
      <!-- 人员类型 -->
      <template v-if="isManage">
        <van-field
          label="人员类型"
          required
          rows="1"
          autosize
          type="textarea"
          v-model="yjInfo.position"
          readonly
        />
      </template>
      <template v-else>
        <van-field
          label="人员类型"
          required
          rows="1"
          autosize
          type="textarea"
          v-model="yjInfo.position"
          readonly
          @click="showuUerType = true"
          :rules="[{ required: true, message: '请选择人员类型' }]"
          placeholder="请选择人员类型"
        />
      </template>
      <van-popup v-model="showuUerType" round position="bottom">
        <van-picker
          title="请选择人员类型"
          show-toolbar
          :columns="filterPositionList"
          @confirm="onConfirm"
          @cancel="onCancel"
        />
      </van-popup>
      <!-- 所在单位 -->
      <van-field
        required
        label="所属单位"
        v-model="branch"
        readonly
        placeholder="请选择所属单位"
      />
      <div class="handle_btn">
        <van-button
          round
          block
          plain
          type="info"
          class="cancel_btn"
          @click="cancelHandle"
          >取消</van-button
        >
        <van-button round block type="info" class="save_btn" @click="saveHandle"
          >保存</van-button
        >
      </div>
    </van-form>
  </div>
</template>

<script>
export default {
  name: "editProfile",
  data() {
    return {
      showuUerType: false,
      branch:'',
      positionList:[
        '林区周边居住群众',
        '经营单位人员',
        '护林巡查人员',
        '进山入林游玩人员',
        '进山施工作业人员',
        '重点单位驻地人员',
        '林区周边居住群众',
        '森林消防专业队伍人员',
        '电路电力设施巡护巡检人员'
      ],
      userInfo: {
        name: "",
        idCardNo: "",
        gender: "",
        birthday: "",
      },
      yjInfo: {
        enterType:'',
        position: "", // 人员类型
      },
      showBirthdayPicker: false,
      minDate: new Date(1900, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(2000, 0, 1),
      isManage: true, //是否为管理员
      positionObj:{
        51:[//林业
          '林区周边居住群众',
          '经营单位人员',
          '护林巡查人员',
          '进山入林游玩人员',
          '进山施工作业人员',
          '重点单位驻地人员',
        ],
        50:[//政府
          '林区周边居住群众',
        ],
        54:[
          '森林消防专业队伍人员',
        ],
        55:[
          '电路电力设施巡护巡检人员'
        ],
        52:[
            '应急主管部门管理人员'
        ],
        53:[
            '公安主管部门管理人员'
        ]
      },
    };
  },
  computed:{
    filterPositionList(){
        return this.positionObj[this.yjInfo.enterType] || []
    }
  },
  mounted() {
    this.getData();
    this.findByCurr();
  },
  methods: {
    onCancel() {
      this.showuUerType = false;
    },
    onConfirm(item) {
      this.showuUerType = false;
      this.yjInfo.position = item
    },
    findByCurr() {
      const params = { dataType:1 }
      this.$api.sdyjCommonUser.findByCurr(params).then((res) => {
        if (res.success && res.data) {
          if(res.data.userType == 1){//监管人员
            this.isManage = true
            // 所属单位回显
            this.branch = res.data.gbEmployer;
          }else{
            this.isManage = false
            // 所属单位回显
            this.branch = res.data.entName;
          }
          console.log("this.isManage", this.isManage);
          this.yjInfo.position = res.data.position
          this.yjInfo.enterType = res.data.enterType
        }
      });
    },
    getData() {
      this.$api.user.findUser().then((res) => {
        if (res.code == 0 && res.success) {
          this.userInfo = Object.assign({}, this.userInfo, res.data);
          this.currentDate = new Date(res.data.birthday);
        }
      });
    },
    toIdentify() {
      this.$router.push("/idcard");
    },
    //picker 选择框确定
    birthdayOnConfirm(date) {
      console.log(date);
      this.userInfo.birthday = this.formatime(date);
      this.showBirthdayPicker = false;
    },
    // 格式化时间
    formatime(dayCount) {
      const createtime = new Date(dayCount);
      const year = createtime.getFullYear();
      let month = createtime.getMonth() + 1;
      let day = createtime.getDate(); // 几号
      month = month < 10 ? "0" + month : month;
      day = day < 10 ? "0" + day : day;
      return year + "-" + month + "-" + day + " 00:00:00";
    },
    cancelHandle() {
      this.$router.back();
    },
    //保存
    saveHandle() {
      this.$refs.validateForm
        .validate()
        .then(() => {
          // console.log(this.userInfo);
          if(this.isManage){
            this.$api.user.updateUser(this.userInfo).then((res) => {
                if(res.success){
                    this.$toast({
                        message: "保存成功",
                    });
                    this.$router.back();
                }
            });
          }else{//非管理员可以修改人员类型
            Promise.all([this.saveUserInfo(),this.saveYjInfo()]).then(() => {
                this.$toast({
                    message: "保存成功",
                });
                this.$router.back();
            })
          }
        })
        .catch((error) => {
          console.log(error);
          this.$toast({
            message: error[0].message,
            className: "errorTY",
          });
        });
    },
    saveUserInfo(){
        return new Promise((resolve,reject) => {
            this.$api.user.updateUser(this.userInfo).then((res) => {
                if(res.success){
                    resolve()
                }else{
                    reject()
                }
            });
        })
    },
    saveYjInfo() {
      const params = { dataType:1 }
      return new Promise((resolve,reject) => {
            this.$api.sdyjCommonUser.updateSdyjWhpUser(params,this.yjInfo).then((res) => {
                if (res.success) {
                    resolve()
                }else{
                    reject()
                }
            });
        })
    },
  },
};
</script>

<style lang="stylus" scoped>
.editProfile {
  // height: 100vh;
  background: #f5f6fa;
  overflow: auto;

  .photo_box {
    position: relative;
    width: 200px;
    height: 280px;
    border-radius: 10px;
    overflow: hidden;
  }

  .my_photo {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;

    img {
      width: 100%;
      height: 100%;
    }

    .tips {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 200px;
      height: 56px;
      background-color: rgba(0, 0, 0, 0.4);
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .re_uploadImg {
      width: 112px;
      height: 28px;
    }
  }

  .file_box {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #f7f8fa;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .file {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
  }

  .space {
    height: 16px;
    width: 100%;
  }

  .handle_btn {
    width: 750px;
    height: 112px;
    background: #FFFFFF;
    box-shadow: 0px 1px 0px 0px #EAEAEA;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 48px;

    .cancel_btn {
      width: 332px;
      height: 88px;
      border-radius: 50px;
      border: 1px solid #1972FF;
      margin-right: 26px;
      color: #1972FF;
      font-size: 32px;
    }

    .save_btn {
      width: 332px;
      height: 88px;
      background: #1972FF;
      border-radius: 50px;
      font-size: 32px;
      color: #FFFFFF;
    }
  }

  .van-action-sheet__header {
    font-weight: 600;
  }
}
</style>
<style lang="stylus">
.editProfile {
  .van-uploader__wrapper {
    width: 100%;
    height: 100%;

    .van-uploader__upload {
      width: 100%;
      height: 100%;
      margin: 0;
    }
  }

  .van-cell {
    min-height: 2.773rem;
    padding-left: 1.2rem;
    padding-right: 0.8rem;
    display: flex;
    align-items: center;
  }

  .van-cell--required::before {
    left: 0.8rem;
  }

  .van-cell.photo_wrap {
    align-items: flex-start;
    padding-top: 0.96rem;
    padding-bottom: 1.066rem;
  }

  .van-cell.block_field {
    display: block;
    padding-top: 0.8rem;
    padding-bottom: 0.9rem;

    .radio_group {
      margin-top: 0.9rem;
    }
  }
}

.van-toast.errorTY {
  background-color: #FF5758 !important;
}
</style>
